@if (step === 'select-contact') {
  <app-select-invoice-contact [customer]="selectedCustomer" (selected)="onContactSelected($event)"
  ></app-select-invoice-contact>
}
@if (subscription && step === 'choose-tariff') {
  <app-tariff-select (back)="cancelWorkflow()"
    [currentTariff]="subscription.tariffPlanDetail?.currentPlan"
    [subscription]="subscription"
    (selected)="onTariffSelected($event)"
  ></app-tariff-select>
}
@if (subscription && tariffFlatOffer && step === 'delivery-date') {
  <app-tariff-place-order
    (back)="onBackTariffDeliveryDate()"
    [selectedTariff]="tariffFlatOffer.tariff_plan"
    [currentTariff]="subscription.tariffPlanDetail.currentPlan"
    (selected)="onSelectTariffDeliveryDate($event)"
  ></app-tariff-place-order>
}
<!--Partner-->
@if (step === 'customer-invoice-address') {
  <app-invoice-address
    [company]="company"
    [onlyEmit]="true"
    [historyBack]="false"
    (backEvent)="onInvoiceBack()"
    [backLabel]="'app_back'"
  (next)="onCustomerInvoiceAddressFilled($event)"></app-invoice-address>
}
@if (step === 'customer-payment-method') {
  <app-payment-method
    [company]="company"
    [historyBack]="false"
    [onlyEmit]="true"
    (backEvent)="onPartnerPaymentBack()"
    [backLabel]="'app_back'" (next)="onPaymentMethodSelected($event)"
  ></app-payment-method>
}
<!--is my-->
@if (step === 'invoice-address') {
  <app-invoice-address [historyBack]="false" (backEvent)="onInvoiceBack()" [backLabel]="'app_back'"  (next)="onInvoiceAddressFilled($event)"></app-invoice-address>
}
@if (step === 'payment-method') {
  <app-payment-method [paymentMethod]="paymentMethod" [historyBack]="false" (backEvent)="onPaymentBack()" [backLabel]="'app_back'" (next)="onPaymentMethodSelected($event)"></app-payment-method>
}
@if (subscription && step === 'checkout-summary') {
  <app-checkout-one-summary
    backLabel="app_cancel"
    [historyBack]="false"
    [subscription]="subscription"
    (back)="onSummaryBack()"
    (buy)="onBuy()"
  ></app-checkout-one-summary>
}
@if (step === 'thank-you') {
  <app-tariff-thankyou
  [applianceId]="applianceId"></app-tariff-thankyou>
}
@if (step === 'thank-you-partner') {
  <app-buy-thankyou-partner  [orderName]="orderName"></app-buy-thankyou-partner>
}
